import { PrivateInterceptorsPR } from "../../Base/interceptors/PrivateinterceptorsPR";

export const getCompanyRevisados = async() =>{
    const result = await PrivateInterceptorsPR(`proveedores/CompanyRevisado`, 'GET')
    return result
}